import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class RecommendationsApi extends Api {
  readonly url = process.server
    ? "/v1/ltk_profile_recommendations/"
    : "/v1/recommendations/ltk_profile_recommendations/";

  constructor($axios: Context["$axios"]) {
    super("recommendationsService", $axios);
  }

  async getRecommenedProfile(limit: number) {
    return await this.request<ManyProfilesResponse>({
      method: "GET",
      params: {
        limit,
      },
    });
  }
}
